export default "<div mat-dialog-content class=\"row text-center\">\r\n    <img class=\"col-lg-12\" [src]=\"imgSrc\">\r\n</div>";